import { render, staticRenderFns } from "./ShippedArticlesMaterials.vue?vue&type=template&id=8b6ce9de&scoped=true"
import script from "./ShippedArticlesMaterials.vue?vue&type=script&lang=js"
export * from "./ShippedArticlesMaterials.vue?vue&type=script&lang=js"
import style0 from "./ShippedArticlesMaterials.vue?vue&type=style&index=0&id=8b6ce9de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6ce9de",
  null
  
)

export default component.exports